export const TABLENAMES = {
    ADMIN_USER_DEVICES: 'adminUsersDevices',
    ADMIN_USERS_PAGE: 'adminUsersPage',
    APP_DETAILS_VENDOR_INCIDENTS: 'appDetailsVendorIncidents',
    APP_USERS: 'appUsers',
    CLIENTAPPS: 'clientApps',
    GLOBAL_APPS: 'globalApps',
    GLOBAL_TENANTS: 'globalTenants',
    INTEGRATION_USERS: 'integrationUsers',
    PARTNER_CLIENTS: 'partnerClients',
    RECENTLY_ADDED_APPS: 'recentlyAddedApps',
    REPORT_APPLICATION_OVERLAP_SUB_CATEGORY_USAGE_BREAKDOWN:
        'reportApplicationOverlapSubCategoryUsageBreakdown',
    SAAS_OPS_RECIPES: 'saasOpsRecipes',
    TAG_EDITOR: 'tagEditor',
    TAGS_COMPONENT: 'tagsComponent',
    USAGE_BREAKDOWN: 'usageBreakdown',
    USAGE_VS_ADOPTION: 'usageVsAdoption',
    USER_APP_ACTIVITY: 'userApplicationActivity',
    USER_APPS: 'userApps'
};
